import { IReportService } from "../../service/report/ReportService";

export default class GetDataReport1Interactor {
  private reportService: IReportService;

  constructor(reportService) {
    this.reportService = reportService;
  }

  async execute(formVersionId: number, includePublicAttribute: boolean) {
    return this.reportService.getReport1Data(
      formVersionId,
      includePublicAttribute
    );
  }
}
